export enum Page {
    SLEEP
}